export default __webpack_public_path__ + "static/media/dragonpay.9ca56b00.svg";